import RewardList from 'components/CreditCard/Rewards/RewardList/RewardList';
import withGlobalModals from 'hocs/withGlobalModals';

export default withGlobalModals(RewardList);
